import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[OnlyNumber]'
})
export class OnlyNumberDirective {

  constructor(private el: ElementRef) { }

  @Input() OnlyNumber: boolean;
  @Input() value: string;

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    const e = <KeyboardEvent> event;
    if (this.OnlyNumber) {

        if ( e.keyCode >= 35 && e.keyCode <= 39) {
            return;
        }
        // Custom
        if (e.keyCode === 86 && (e.ctrlKey || e.metaKey)){
            e.preventDefault();
        }
      }
  }

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    const e = <KeyboardEvent> event;
    event = (event) ? event : window.event;
    const charCode = (event.which) ? event.which : event.keyCode;
    if (this.OnlyNumber) {
        /*if (this.value.indexOf('.') === -1 && charCode === 46) {
            return;
        }*/
        if ([ 8, 9, 27, 13, 190].indexOf(charCode) !== -1) {
            return;
        }
          // Custom
        if (charCode === 39) {
            e.preventDefault();
        }
        if (charCode >= 97 && charCode <=  122) {
            e.preventDefault();
        }
          // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (charCode < 48 || charCode > 57)) && (charCode < 96 || charCode > 105))  {
              e.preventDefault();
        }
    }
  }
}
